import { render, staticRenderFns } from "./StepThird.vue?vue&type=template&id=7985ff3c&scoped=true&"
import script from "./StepThird.vue?vue&type=script&lang=js&"
export * from "./StepThird.vue?vue&type=script&lang=js&"
import style0 from "./StepThird.vue?vue&type=style&index=0&id=7985ff3c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7985ff3c",
  null
  
)

export default component.exports